import React from 'react';
import { compose, withHandlers, withPropsOnChange, withState, lifecycle } from 'recompose';
import { reduxForm, Field } from 'redux-form';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import { TextField } from 'redux-form-material-ui';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { Select as Select2 } from 'redux-form-material-ui';
import { sortBy, get, find, compact, filter, isArray, isEmpty, includes } from 'lodash';
import { users as getAllUsers } from '../../users/_api';
import { connect } from 'react-redux';
import { getFormValues, FieldArray } from 'redux-form';
import moment from 'moment';
import { startReservation } from '../_api';
import withLoader from '../../app/withLoader';
import Paper from '@material-ui/core/Paper';
import { readContact } from '../../users/_api';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import { typeActivity } from '../config';
import Select from 'react-select';
import { allServices } from '../../services/_api';
import { categories as allCategories } from '../../categories/_api';
import withCountPriceServeItem from '../withCountPriceServeItem';
import { Autocomplete } from '../../../components/forms/Autocomplete';
import queryString from 'query-string';
import { actualPrice, actualPricePerPerson } from '../../../utils/';
import { renderToggleInput } from '../../../components/forms/Toggle';
import { getConfig } from '../../item-services/_api';

const styles = (theme) => ({
  paper: { padding: 15, marginBottom: 15, marginTop: 20 },
});

const onKeyDown = (e) => {
  console.log(e.code);
  if (e.code === 'Enter') e.preventDefault();
};

const enhance = compose(
  withStyles(styles),
  withRouter,
  withLoader,
  connect((state) => {
    const from = get(getFormValues('addReservationForm')(state), 'from', null);
    const to = get(getFormValues('addReservationForm')(state), 'to', null);
    const personsValue = get(getFormValues('addReservationForm')(state), 'persons', null);
    const arrCatAndId = [];
    if (isArray(personsValue)) {
      personsValue.forEach((person) => {
        if (!isEmpty(get(person, 'items')) && isArray(Object.keys(person.items))) {
          Object.keys(person.items).forEach((key) => {
            person.items[key].forEach((itemIn) => {
              if (itemIn && itemIn.item) {
                const item = get(itemIn, 'item.value');
                // Uložit do pole použité id v rámci kategorie (odebrat z nabídky)
                arrCatAndId.push(`${key}-${item.id}`);
              }
            });
          });
        }
      });
    }
    return {
      type: get(getFormValues('addReservationForm')(state), 'type', null),
      userId: get(getFormValues('addReservationForm')(state), 'userId.value', null),
      personId: get(getFormValues('addReservationForm')(state), 'personId.value', null),
      fromForm: from,
      toForm: to,
      from: from ? moment(from).format('YYYY-MM-DD 00:00:00') : null,
      to: to ? moment(to).format('YYYY-MM-DD 23:59:59') : null,
      personsValue,
      initialValues: {
        from: moment().format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
        services: {},
        sendEmail: true,
      },
      addNewItem: get(getFormValues('addReservationForm')(state), 'addNewItem', null),
      discountInPercent: get(getFormValues('addReservationForm')(state), 'discountInPercent', null),
      discountInAmount: get(getFormValues('addReservationForm')(state), 'discountInAmount', null),
      isAllSeason: get(getFormValues('addReservationForm')(state), 'isAllSeason', false),
      arrCatAndId,
    };
  }),
  withState('users', 'setUsers', null),
  withState('persons', 'setPersons', null),
  withState('services', 'setServices', []),
  withState('items', 'setItems', []),
  withState('categories', 'setCategories', []),
  withState('endOfSeason', 'setEndOfSeason', null),
  withHandlers({
    loadPersons:
      ({ users, setPersons }) =>
      async (userId, usersFrom = null) => {
        const resp = await readContact(userId);
        let persons = get(resp, 'data.items', []).map((item) => ({
          ...item.contact,
        }));
        persons.push(find(usersFrom || users, { id: userId }));
        setPersons(compact(persons));
      },
  }),
  reduxForm({ form: 'addReservationForm' }),
  lifecycle({
    async componentDidMount() {
      const {
        setUsers,
        setServices,
        setCategories,
        location,
        loadPersons,
        change,
        toggleLoader,
        setEndOfSeason,
      } = this.props;
      const parsed = queryString.parse(get(location, 'search'));
      toggleLoader();
      const [users, services, categories, config] = await Promise.all([
        getAllUsers(),
        allServices(),
        allCategories(),
        getConfig({ config: 'END_OF_SEASON' }),
      ]);
      setUsers(get(users, 'items', []));
      setServices(get(services, 'items', []));
      setCategories(categories);
      setEndOfSeason(get(config, 'endOfSeason', null));
      const userId = get(parsed, 'user');
      if (userId) {
        await loadPersons(parseInt(userId, 10), get(users, 'items', []));
        const userLabel = find(get(users, 'items', []), { id: parseInt(userId, 10) });
        change('userId', {
          value: parseInt(userId, 10),
          label: `${get(userLabel, 'surname') || ''} ${get(userLabel, 'forename') || ''}`,
        });
      }
      toggleLoader(false);
    },
  }),

  withCountPriceServeItem,
  withPropsOnChange(['isAllSeason'], ({ isAllSeason, endOfSeason, change }) => {
    if (isAllSeason) {
      change('to', endOfSeason);
    }
  }),
  withPropsOnChange(['fromForm', 'toForm'], ({ fromForm, toForm, change }) => {
    if (fromForm > toForm) {
      change('to', fromForm);
    }
  }),
  withHandlers({
    loadItems:
      ({ items, setItems, userId, from, to, toggleLoader, countDays, change, serveItems }) =>
      async (type, index) => {
        const daysCount = countDays(from, to);
        const values = {
          userId,
          items: get(find(typeActivity, { id: type }), 'items', []).map((item) => ({
            requestId: item.name,
            categoryId: item.categoryId,
            personId: userId,
            from,
            to,
            filters: [],
          })),
        };
        toggleLoader();
        change(`persons[${index}].items`, {});
        const resp = await startReservation(values);
        if (type === 'downhill') {
          items[index] = {
            type: 'downhill',
            items: {
              shoes: serveItems(get(resp, 'data.items.shoes', []), type, daysCount),
              skies: serveItems(get(resp, 'data.items.skies', []), type, daysCount),
              sticks: serveItems(get(resp, 'data.items.sticks', []), type, daysCount),
              helmets: serveItems(get(resp, 'data.items.helmets', []), type, daysCount),
              sacs: serveItems(get(resp, 'data.items.sacs', []), type, daysCount),
              bags: serveItems(get(resp, 'data.items.bags', []), type, daysCount),
              glasses: serveItems(get(resp, 'data.items.glasses', []), type, daysCount),
              backbone_guard: serveItems(
                get(resp, 'data.items.backbone_guard', []),
                type,
                daysCount
              ),
            },
          };
          setItems(items);
        }
        if (type === 'snowboard') {
          items[index] = {
            type: 'snowboard',
            items: {
              shoes: serveItems(get(resp, 'data.items.shoes', []), type, daysCount),
              snbs: serveItems(get(resp, 'data.items.snbs', []), type, daysCount),
              helmets: serveItems(get(resp, 'data.items.helmets', []), type, daysCount),
              sacs: serveItems(get(resp, 'data.items.sacs', []), type, daysCount),
              glasses: serveItems(get(resp, 'data.items.glasses', []), type, daysCount),
              backbone_guard: serveItems(
                get(resp, 'data.items.backbone_guard', []),
                type,
                daysCount
              ),
            },
          };
          setItems(items);
        }
        if (type === 'crossCountry') {
          items[index] = {
            type: 'crossCountry',
            items: {
              shoes: serveItems(get(resp, 'data.items.shoes', []), type, daysCount),
              skies: serveItems(get(resp, 'data.items.skies', []), type, daysCount),
              sticks: serveItems(get(resp, 'data.items.sticks', []), type, daysCount),
              bags: serveItems(get(resp, 'data.items.bags', []), type, daysCount),
              sacs: serveItems(get(resp, 'data.items.sacs', []), type, daysCount),
            },
          };
          setItems(items);
        }
        if (type === 'bicycleCarrier') {
          items[index] = {
            type: 'bicycleCarrier',
            items: {
              carriers: serveItems(get(resp, 'data.items.carriers', []), type, daysCount),
            },
          };
          setItems(items);
        }
        toggleLoader(false);
      },
    getPersonInfo:
      ({ persons }) =>
      (personId, type) => {
        const person = find(persons, { id: personId });
        const attrs = get(find(typeActivity, { id: type }), 'attributes', []);
        let text = '';
        attrs.map((attr) => {
          const value = get(find(get(person, 'attributes', []), { name: attr }), 'value', '');
          text += `${attr}: ${value || 'neuvedeno'}, `;
          return {};
        });
        return type ? text.slice(0, -2) : '';
      },
  }),
  withHandlers({
    renderMembers:
      ({
        classes,
        renderHobbies,
        persons,
        personId,
        loadItems,
        userId,
        from,
        to,
        items,
        getPersonInfo,
        personsValue,
        change,
        addNewItem,
        services,
        arrCatAndId,
      }) =>
      ({ fields, meta: { error, submitFailed } }) =>
        (
          <div>
            <Grid container spacing={24}>
              <Grid item xs={3}>
                {/*<FormControl style={{ minWidth: 200 }}>
              <InputLabel htmlFor="userId">Jméno osoby</InputLabel>
              <Field
                name="personId"
                component={Select2}
                placeholder="userId"
                disabled={!persons || persons.length === 0}
              >
                {sortBy(persons, ['name']).map(item => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Field>
                </FormControl>*/}
                <Field
                  name="personId"
                  component={(props) => (
                    <Select
                      value={props.input.value}
                      onChange={props.input.onChange}
                      onBlur={() => props.input.onBlur(props.input.value)}
                      options={sortBy(filter(persons, { deleted: false }), ['surname']).map(
                        (item) => ({
                          value: item.id,
                          label: `${item.surname || ''} ${item.forename || ''} (${get(
                            item,
                            'attributes',
                            []
                          )
                            .map((attr) => `${attr.value || ''} ${attr.unit || ''}`)
                            .join(', ')})`,
                        })
                      )}
                      placeholder="Select"
                      simpleValue
                      isDisabled={!persons || persons.length === 0}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Button
                  variant="contained"
                  disabled={!personId}
                  color="primary"
                  onClick={() => fields.push({ personId })}
                >
                  Přidat osobu
                </Button>
              </Grid>
            </Grid>
            {submitFailed && error && <span>{error}</span>}
            <Grid container spacing={24}>
              {fields.map((member, index) => {
                const data = fields.getAll()[index];
                const person = find(persons, { id: get(data, 'personId', '') });
                return (
                  <Grid key={index} item xs={6} md={6} xl={4}>
                    <Paper className={classes.paper}>
                      <Grid container spacing={24} justify="space-between">
                        <Grid item xs={10}>
                          <h4>{`${get(person, 'forename', '')} ${get(person, 'surname', '')}`}</h4>
                          <h6>{getPersonInfo(get(data, 'personId', ''), get(data, 'type'))}</h6>
                        </Grid>
                        <Grid item xs={2} style={{ textAlign: 'right' }}>
                          <IconButton
                            color="secondary"
                            className={classes.button}
                            aria-label="Smazat"
                            onClick={() => fields.remove(index)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                      <Grid item xs={3}>
                        <FormControl style={{ minWidth: 200 }}>
                          <InputLabel htmlFor="type">Typ činnosti</InputLabel>
                          <Field
                            name={`${member}.type`}
                            component={Select2}
                            placeholder="type"
                            onChange={(e, type) => loadItems(type, index)}
                            disabled={!userId || !(from && to ? moment(from) < moment(to) : false)}
                          >
                            {typeActivity.map((item) => (
                              <MenuItem key={item.id} value={item.id}>
                                {item.label}
                              </MenuItem>
                            ))}
                          </Field>
                        </FormControl>
                      </Grid>
                      <div style={{ marginTop: 15 }}>
                        {get(data, 'type', false) && items ? (
                          <Grid container spacing={24} alignItems="flex-end">
                            {find(typeActivity, {
                              id: get(data, 'type', false),
                            }).items.map((category) => {
                              const itemsToShow = get(
                                personsValue[index],
                                `items.${category.name}`,
                                []
                              );
                              const options = compact(
                                get(items, `[${index}].items.${category.name}`, []).map((item2) => {
                                  // Pokud je už id v rámci kategorie použito, pak nelze znovu použít
                                  return includes(arrCatAndId, `${category.name}-${item2.id}`)
                                    ? null
                                    : { label: item2.label, value: item2 };
                                })
                              );
                              if (itemsToShow.length > 0) {
                                return itemsToShow.map((item, i) => {
                                  const itemValue = get(
                                    personsValue[index],
                                    `items.${category.name}[${i}].item`
                                  );
                                  const price = itemValue
                                    ? `${get(itemValue.value, 'price', 0)} Kč`
                                    : '0 Kč';
                                  return (
                                    <React.Fragment key={`${category.name}_${i}`}>
                                      <Grid item xs={9}>
                                        <Autocomplete
                                          name={`${member}.items.${category.name}[${i}].item`}
                                          placeholder="Vyberte"
                                          options={options}
                                          label={category.label}
                                        />

                                        {/*<FormControl style={{ minWidth: 200 }}>
                                      <InputLabel htmlFor={category.name}>
                                        {category.label}
                                      </InputLabel>
                                      <Field
                                        name={`${member}.items.${category.name}[${i}].item`}
                                        component={Select2}
                                        placeholder={category.name}
                                        displayEmpty
                                      >
                                        <MenuItem value={null}> </MenuItem>
                                        {get(items, `[${index}].items.${category.name}`, []).map(
                                          item2 => (
                                            <MenuItem key={item2.id} value={JSON.stringify(item2)}>
                                              {item2.label}
                                            </MenuItem>
                                          ),
                                        )}
                                      </Field>
                                          </FormControl>*/}
                                      </Grid>
                                      <Grid item xs={3}>
                                        {price}
                                      </Grid>
                                    </React.Fragment>
                                  );
                                });
                              } else {
                                const itemValue = get(
                                  personsValue[index],
                                  `items.${category.name}[0].item`
                                );
                                const price = itemValue
                                  ? `${get(itemValue.value, 'price', 0)} Kč`
                                  : '0 Kč';
                                return (
                                  <React.Fragment key={category.name}>
                                    <Grid item xs={9}>
                                      <Autocomplete
                                        name={`${member}.items.${category.name}[0].item`}
                                        placeholder="Vyberte"
                                        options={options}
                                        label={category.label}
                                      />
                                      {/*<FormControl style={{ minWidth: 200 }}>
                                    <InputLabel htmlFor={category.name}>
                                      {category.label}
                                    </InputLabel>
                                    <Field
                                      name={`${member}.items.${category.name}[0].item`}
                                      component={Select2}
                                      placeholder={category.name}
                                      displayEmpty
                                    >
                                      <MenuItem value={null}> </MenuItem>
                                      {get(items, `[${index}].items.${category.name}`, []).map(
                                        item2 => (
                                          <MenuItem key={item2.id} value={JSON.stringify(item2)}>
                                            {item2.label}
                                          </MenuItem>
                                        ),
                                      )}
                                    </Field>
                                        </FormControl>*/}
                                    </Grid>
                                    <Grid item xs={3}>
                                      {price}
                                    </Grid>
                                  </React.Fragment>
                                );
                              }
                            })}
                            <Grid item xs={12}>
                              <Grid container spacing={24} alignItems="flex-end">
                                <Grid item xs={12}>
                                  <FormControl style={{ minWidth: 200 }}>
                                    <InputLabel htmlFor={'addNewItem'}>
                                      Vyberte kategorii
                                    </InputLabel>
                                    <Field
                                      name={'addNewItem'}
                                      component={Select2}
                                      placeholder={'Vyberte kategorii'}
                                      displayEmpty
                                    >
                                      {get(
                                        find(typeActivity, {
                                          id: get(data, 'type', false),
                                        }),
                                        'items',
                                        []
                                      ).map((item2) => (
                                        <MenuItem key={item2.name} value={item2.name}>
                                          {item2.label}
                                        </MenuItem>
                                      ))}
                                    </Field>
                                  </FormControl>

                                  <Button
                                    variant="outlined"
                                    onClick={() => {
                                      const itemValue = get(
                                        personsValue[index],
                                        `items.${addNewItem}`
                                      );
                                      change(
                                        `${member}.items.${addNewItem}[${
                                          itemValue ? itemValue.length : 0
                                        }]`,
                                        null
                                      );
                                    }}
                                  >
                                    Přidat
                                  </Button>
                                </Grid>
                                {services.map((item) => (
                                  <Grid item xs={6} key={item.id}>
                                    <Field
                                      name={`services.${get(data, 'personId', '')}.${item.id}`}
                                      component={TextField}
                                      label={item.name}
                                      className={classes.textFields}
                                      fullWidth
                                      type="number"
                                      /*onChange={(e, value) =>
                                    change(`servicesForUsers.[${item.id}]`, [
                                      {
                                        quantity: parseInt(value, 10),
                                        personId: get(data, 'personId', '')
                                      }
                                    ])
                                  }*/
                                    />
                                  </Grid>
                                ))}
                                <Grid item xs={9}></Grid>
                                <Grid item xs={3}>
                                  <b>{`${actualPricePerPerson(
                                    get(personsValue, `[${index}].items`, {})
                                  )} Kč`}</b>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        ) : null}
                      </div>
                    </Paper>
                  </Grid>
                );
              })}
            </Grid>
          </div>
        ),
  })
);

export default enhance(
  ({
    classes,
    handleSubmit,
    setAddUser,
    setEdit,
    edit,
    history,
    users,
    type,
    items,
    userId,
    loadItems,
    from,
    to,
    renderMembers,
    loadPersons,
    onSubmit,
    personsValue,
    countDays,
    services,
    discountInPercent,
    discountInAmount,
    isAllSeason,
    endOfSeason,
  }) => (
    <form
      onKeyDown={onKeyDown}
      className={classes.form}
      onSubmit={handleSubmit((values) => onSubmit({ ...values, countDays: countDays(from, to) }))}
    >
      <Grid container spacing={24}>
        <Grid item xs={3}>
          <Field
            name="userId"
            component={(props) => (
              <Select
                value={props.input.value}
                onChange={(values, options) => {
                  props.input.onChange(values, options);
                  loadPersons(get(values, 'value', null));
                }}
                onBlur={() => props.input.onBlur(props.input.value)}
                options={sortBy(users, ['surname']).map((item) => ({
                  value: item.id,
                  label: `${item.surname || ''} ${item.forename || ''}`,
                }))}
                placeholder="Select"
                simpleValue
                isDisabled={(personsValue || []).length > 0}
              />
            )}
          />
        </Grid>
        <Grid item xs={2}>
          <Field
            name="from"
            component={TextField}
            label="Od"
            className={classes.textFields}
            type="date"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <Field
            name="to"
            component={TextField}
            label="Do"
            className={classes.textFields}
            type="date"
            InputLabelProps={{
              shrink: true,
            }}
            disabled={isAllSeason}
          />
        </Grid>
        {endOfSeason && (
          <Grid item xs={3}>
            <Field
              name="isAllSeason"
              id="isAllSeason"
              label="Celosezónní výpůjčka"
              component={renderToggleInput}
            />
          </Grid>
        )}
        <Grid item xs={2}>
          <b>Počet dnů: {countDays(from, to) || ''}</b>
        </Grid>
        <Grid item xs={6}>
          <Field
            name="note"
            component={TextField}
            label="Poznámka"
            className={classes.textFields}
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <Field
            name="discountInPercent"
            component={TextField}
            label="Sleva (%)"
            className={classes.textFields}
            fullWidth
            props={{ disabled: !!discountInAmount }}
          />
        </Grid>
        <Grid item xs={3}>
          <Field
            name="discountInAmount"
            component={TextField}
            label="Sleva (Kč)"
            className={classes.textFields}
            fullWidth
            props={{ disabled: !!discountInPercent }}
          />
        </Grid>
        <Grid item xs={12}>
          <FieldArray name="persons" component={renderMembers} />
        </Grid>
        <Grid item xs={12}>
          <b>Cena celkem: {actualPrice(personsValue || [])} Kč</b>
        </Grid>
        <Grid item xs={9}>
          <Field
            name="sendEmail"
            id="sendEmail"
            label="Odeslat email zákazníkovi"
            component={renderToggleInput}
          />
        </Grid>
        <Grid item xs={12}>
          <div>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className={classes.submit}
              disabled={!personsValue}
            >
              Uložit
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                history.push('/reservations');
              }}
            >
              Zrušit
            </Button>
          </div>
        </Grid>
      </Grid>
    </form>
  )
);



// WEBPACK FOOTER //
// ./src/modules/reservations/form/addForm.js